import type { DemoKey } from './keys';

export const de: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Geometrie · 3D',
  'panel.figure': 'Figur',
  'panel.dims': 'Maße',
  'panel.style': 'Aussehen',
  'panel.lines': 'Spezielle Linien',
  'style.body': 'Körper',
  'style.line': 'Linie',
  'style.cut': 'Schnitt',
  'style.labels': 'Eckpunktbeschriftung',
  'group.face': 'Flächendiagonalen / Mantellinien',
  'group.space': 'Diagonalen / Achsen / Mittellinien',
  'split.label': 'Schnitt',
  'btn.animate': 'Animieren',
  'btn.reset': 'Zurücksetzen',
  'hint.line1': 'Ziehen zum Drehen · Scrollen zum Zoomen',
  'hint.line2': 'Klicke auf eine Linie zur Auswahl',
  'fig.cuboid': 'Quader',
  'fig.cube': 'Würfel',
  'fig.triPrism': 'Dreiseitiges Prisma',
  'fig.hexPrism': 'Sechsseitiges Prisma',
  'fig.tetrahedron': 'Tetraeder',
  'fig.squarePyramid': 'Quadratische Pyramide',
  'fig.cylinder': 'Zylinder',
  'fig.cone': 'Kegel',
  'fig.sphere': 'Kugel',
  'fig.frustumPyramid': 'Pyramidenstumpf',
  'fig.frustumCone': 'Kegelstumpf',
  'dim.length': 'Länge',
  'dim.width': 'Breite',
  'dim.height': 'Höhe',
  'dim.side': 'Seite',
  'dim.radius': 'Radius',
  'dim.r1': 'unterer Radius',
  'dim.r2': 'oberer Radius',
  'dim.sideBase': 'Grundkante',
  'dim.sideTop': 'Deckkante',
  'info.face': 'Fläche',
  'info.center': 'durch Mitte',
  'info.diagonal': 'Diagonale',
  'info.axial': 'Achsendiagonale',
  'info.diameter': 'Durchmesser',
  'info.generator': 'Mantellinie',
  'info.axis': 'Achse',
  'info.height': 'Höhe',
  'info.median': 'Seitenhalbierende',
  'info.apothem': 'Apothem',
  'info.diameterBase': 'Grunddurchmesser',
  'info.diameterTop': 'Deckdurchmesser',
};
